export default __webpack_public_path__ + "static/media/ic-house.316e71ad.svg";